import React from 'react'
import 'stylesheets/TimerAppStyles/CreateFirstTodo.css'

const CreateFirstTodo = () => {
  return (
    <div className='firstTodo-container'>
      <p>Create your first TO-DO!</p>
    </div>
  )
}

export {CreateFirstTodo}